import React, {Component} from 'react';
import Reveal from 'react-reveal';
import Player2 from "../Banner/videobtn2";
class AppFeatures extends Component{
    state = {
        open: false
    };

    onOpenModal = () => {
        this.setState(prevState => ({
            open: !prevState.open
        }));
    };
    render() {
        return(
            <section className="app_featured_area_two" id="features">
                <div className="triangle_shape"/>
                <div className="container">
                    <div className="row app_feature_info">
                        <div className="col-lg-5">
                            <div className="app_img">
                                <div className="dot dot_one wow fadeIn" data-wow-delay="0.5s"><span className="dot1"/><span className="dot2"/></div>
                                <div className="dot dot_two wow fadeIn" data-wow-delay="0.8s"><span className="dot1"/><span className="dot2"/></div>
                                <div className="dot dot_three wow fadeIn" data-wow-delay="0.3s"><span className="dot1"/><span className="dot2"/></div>
                                <Reveal effect="fadeInLeft" duration={2500}><img className="text_bg one" src={require('../../img/home7/text_one.png')} alt=""/></Reveal>
                                <Reveal effect="fadeInDown" duration={2000}><img className="text_bg two" src={require('../../img/home7/text_three.png')} alt=""/></Reveal>
                                <Reveal effect="fadeInRight" duration={1500}><img className="text_bg three" src={require('../../img/home7/text_two.png')} alt=""/></Reveal>
                                <img className="wow fadeIn phone_img" src={require('../../img/home7/iPhonex.png')} alt=""/>
                            </div>
                        </div>
                        <div className="col-lg-7 d-flex align-items-center">
                            <Reveal bottom cascade>
                                <div className="app_featured_content">
                                    <h2 className="f_p f_size_30 f_700 t_color3 l_height45 mb-30">Welcome to GreenHubLK!</h2>
                                    <p className="f_400">GreenHubLK is a user friendly plant diagnostic mobile application that revolutionizes farming with a little help from deep learning. This innovative mobile app , facilitates the users with four different novel features namely , Plant Disease Identification , Direct buy and Sell , Vegetable Price prediction and Food Banking concept.</p>
                                    <button className="app_btn btn_hover mt_40" onClick={this.onOpenModal}><i className="ti-control-play"/>&nbsp;&nbsp; Watch Demo</button>
                                    <Player2 open={this.state.open} toggleModal={this.onOpenModal} />
                                </div>
                            </Reveal>
                        </div>
                    </div>
                </div>
            </section>
        )
    }


}
export default AppFeatures;
